module.exports = __webpack_public_path__ + "img/VASCO.89b348d4.jpeg";